import chev from "assets/icons/chevron.svg";

export default function Mobile() {
  return (
    <div className="w-[100%] h-[100%] flex items-center justify-center">
      <div className="w-[95%] h-[95%] shadow-[0_30px_50px_-15px_rgba(0,0,0,0.3)] border-2 border-[#DDDDDD] flex items-center justify-center flex-col  p-[10px] rounded-lg">
        <div className="w-[90%] h-[15%]  flex flex-col items-start justify evenly border-b border-[#C3C3C3] ">
          <h1 className="text-[24px] font-bold">Set Staff Permissions</h1>
          <p className="text-[14px] font medium">
            Manage staff authorization for the profile
          </p>
        </div>
        <div className="w-[100%] h-[82%] flex flex-col items-center justify-center gap-[10px]">
          <div className="w-[100%] h-[22%] flex items-center justify-center border-b border-[#C3C3C3]">
            <div className="w-[60%] h-[100%] flex items-center justify-start gap-[10px]">
              <div className="w-[50px] h-[50px]  rounded-full bg-red-700"></div>
              <div className="w-[55%] h-[100%] flex flex-col justify-center">
                <h1 className=" text-[16px] font-[#000000]">Wisdom Ibu</h1>
                <p className="text-[12px] font-[#898989]">
                  wisdomibu@gmail.com
                </p>
              </div>
            </div>
            <div className="w-[22%] h-[100%] flex items-center justify-center gap-[5px]">
              <h1 className="text-[15px]">2</h1>
              <img src={chev} alt="" className="w-[15%] h-[15%] fit-contain" />
            </div>
            <div className="w-[22%] h-[100%] flex items-center justify-end gap-[5px]">
              <h1 className="text-[12px]">Can Edit</h1>
              <img src={chev} alt="" className="w-[15%] h-[15%] fit-contain" />
            </div>
          </div>
          <div className="w-[100%] h-[22%] flex items-center justify-center border-b border-[#C3C3C3]">
            <div className="w-[60%] h-[100%]  flex items-center justify-start gap-[10px]">
              <div className="w-[50px] h-[50px] rounded-full bg-red-700"></div>
              <div className="w-[55%] h-[100%] flex flex-col justify-center">
                <h1 className=" text-[16px] font-[#000000]">Wisdom Ibu</h1>
                <p className="text-[12px] font-[#898989]">
                  wisdomibu@gmail.com
                </p>
              </div>
            </div>
            <div className="w-[22%] h-[100%]  flex items-center justify-center gap-[5px]">
              <h1 className="text-[15px]">2</h1>
              <img src={chev} alt="" className="w-[15%] h-[15%] fit-contain" />
            </div>
            <div className="w-[22%] h-[100%] flex items-center justify-end gap-[5px]">
              <h1 className="text-[12px]">Can Edit</h1>
              <img src={chev} alt="" className="w-[15%] h-[15%] fit-contain" />
            </div>
          </div>
          <div className="w-[100%] h-[22%] flex items-center justify-center border-b border-[#C3C3C3]">
            <div className="w-[60%] h-[100%] flex items-center justify-start gap-[10px]">
              <div className="w-[50px] h-[50px] rounded-full bg-red-700"></div>
              <div className="w-[55%] h-[100%] flex flex-col justify-center">
                <h1 className=" text-[16px] font-[#000000]">Wisdom Ibu</h1>
                <p className="text-[12px] font-[#898989]">
                  wisdomibu@gmail.com
                </p>
              </div>
            </div>
            <div className="w-[22%] h-[100%] flex items-center justify-center gap-[5px]">
              <h1 className="text-[15px]">2</h1>
              <img src={chev} alt="" className="w-[15%] h-[15%] fit-contain" />
            </div>
            <div className="w-[22%] h-[100%] flex items-center justify-end gap-[5px]">
              <h1 className="text-[12px]">Can Edit</h1>
              <img src={chev} alt="" className="w-[15%] h-[15%] fit-contain" />
            </div>
          </div>
          <div className="w-[100%] h-[22%] flex items-center justify-center border-b border-[#C3C3C3]">
            <div className="w-[60%] h-[100%]  flex items-center justify-start gap-[10px]">
              <div className="w-[50px] h-[50px] rounded-full bg-red-700"></div>
              <div className="w-[55%] h-[100%] flex flex-col justify-center">
                <h1 className=" text-[16px] font-[#000000]">Wisdom Ibu</h1>
                <p className="text-[12px] font-[#898989]">
                  wisdomibu@gmail.com
                </p>
              </div>
            </div>
            <div className="w-[22%] h-[100%]  flex items-center justify-center gap-[5px]">
              <h1 className="text-[15px]">2</h1>
              <img src={chev} alt="" className="w-[15%] h-[15%] fit-contain" />
            </div>
            <div className="w-[22%] h-[100%] flex items-center justify-end gap-[5px]">
              <h1 className="text-[12px]">Can Edit</h1>
              <img src={chev} alt="" className="w-[15%] h-[15%] fit-contain" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
